import { useTranslation } from 'react-i18next';

import { Lock150Icon } from 'public/assets/icons';
import { PrivateContentPlaceholderWrap } from './PrivateContentPlaceholder.style';

interface IPrivateContentPlaceholder {
  type?: 'group' | 'user' | 'event';
}

export const PrivateContentPlaceholder = ({
  type,
}: IPrivateContentPlaceholder) => {
  const { t } = useTranslation();

  const getPrivateText = () => {
    switch (type) {
      case 'event':
        return t('event:privateEventContent');

      case 'group':
        return t('profile:PrivateGroupContent');

      case 'user':
        return t('profile:privateProfile');

      default:
        return '';
    }
  };

  return (
    <PrivateContentPlaceholderWrap>
      <Lock150Icon />
      <span>{getPrivateText()}</span>
    </PrivateContentPlaceholderWrap>
  );
};
